import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import AdvancedLazyImage from "./AdvancedLazyImage";
import { t } from "i18next";

const Products = () => {
  const products = [
    {
      id: 1,
      nameKey: "workshop_equipment",
      image: "img/Co-logos/img1.png",
      descriptionKey: "workshop_equipment_desc",
    },
    {
      id: 2,
      nameKey: "factory_supplies",
      image: "img/Co-logos/img2.png",
      descriptionKey: "factory_supplies_desc",
    },
    {
      id: 3,
      nameKey: "screws_accessories",
      image: "img/Co-logos/img3.png",
      descriptionKey: "screws_accessories_desc",
    },
  ];

  return (
    <div className="container-fluid product py-5 my-5">
      <div className="container py-5">
        {/* العنوان */}
        <div
          className="section-title text-center mx-auto wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "500px" }}
        >
          <p className="fs-5 fw-medium fst-italic text-primary">
            {t('our_fields')}
          </p>
          <h1 className="display-6">{t('products_title')}</h1>
        </div>

        {/* مكون Swiper */}
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          breakpoints={{
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
          style={{ paddingBottom: "40px" }}
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <div className="p-3">
                <div className="d-block product-item rounded">
                  <AdvancedLazyImage
                    src={product.image}
                    alt={t(product.nameKey)}
                    imgclassName="w-100 rounded"
                  />
                  <div className="bg-white shadow-sm text-center p-4 position-relative mt-n5 mx-4">
                    <h4 className="text-primary">{t(product.nameKey)}</h4>
                    <span className="text-body">{t(product.descriptionKey)}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Products;